/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var ModuleDependency = require("./ModuleDependency");

function LoaderDependency(request) {
	ModuleDependency.call(this, request);
}
module.exports = LoaderDependency;

LoaderDependency.prototype = Object.create(ModuleDependency.prototype);
LoaderDependency.prototype.constructor = LoaderDependency;
LoaderDependency.prototype.type = "loader";



//////////////////
// WEBPACK FOOTER
// (webpack)/lib/dependencies/LoaderDependency.js
// module id = 4150
// module chunks = 0